import makeStyles from '@mui/styles/makeStyles';

export const useMultiStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    title: {
        fontWeight: 'bold',
        marginBottom: 10,
        fontSize: 16,
    },
    historyList: {
        maxWidth: 350,
        minWidth: 350,
        paddingRight: 10,
        overflow: 'auto',
    },
    outcome: {
        overflow: 'auto',
        paddingRight: 10,
    },
    divider: {
        margin: '5px 10px',
        border: `1px solid ${theme.palette.inPatient.inputBackground}`,
        height: 'auto',
    },
    sectionItem: {
        marginTop: 10,
        borderRadius: 8,
        display: 'inline-flex',
        width: 'calc(100% - 5px)',
        cursor: 'pointer',
        padding: '7px 10px',
        fontWeight: 'normal',
        lineHeight: '24px',
        fontSize: '10px',
        backgroundColor: theme.palette.inPatient.inputBackground,
        borderLeft: '2px solid #4EAC6F',
        '&.selected': {
            backgroundColor: '#295995',
        },
        '&.canceled': {
            borderLeftColor: '#e2757a',
            textDecoration: 'line-through',
        },
    },
    multiRoot: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
    },
    scoreBox: {
        width: 25,
        height: 25,
        backgroundColor: theme.palette.inPatient.formBackground,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));